module.exports = __webpack_public_path__ + "static/HipPush-Squat-ff3533ee605498e4ea8fb09c66802884.mp4";